export default "__VITE_ASSET__C65E2oxh__"